var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailColored(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 35,
    viewBox: "0 0 43 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.9 2H37.1C39.245 2 41 3.755 41 5.9V29.3C41 31.445 39.245 33.2 37.1 33.2H5.9C3.755 33.2 2 31.445 2 29.3V5.9C2 3.755 3.755 2 5.9 2Z",
    stroke: "#0174EB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41 5.54541L21.5 19.7272L2 5.54541",
    stroke: "#0174EB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailColored);
export default __webpack_public_path__ + "static/media/mailColored.8e3b01552a3df37650c35d7a3ac9ce5f.svg";
export { ForwardRef as ReactComponent };